/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';

// Build a query string with the single-user pin + optional date window.
export const q = (userId, from, to, extra = {}) => {
  const p = new URLSearchParams();
  if (userId) p.set('user_id', userId);
  if (from) p.set('from_date', from);
  if (to) p.set('to_date', to);
  Object.entries(extra).forEach(([k, v]) => { if (v != null && v !== '') p.set(k, v); });
  return p.toString();
};

export const num = (v, d = '—') => (v == null || Number.isNaN(Number(v)) ? d : Math.round(Number(v)));

// When `to` is set the whole box becomes a link to that user's per-type detail page.
export const Kpi = ({ label, value, unit, sub, to }) => {
  const body = (
    <>
      <div className="ud-kpi__label">
        {label}
        {to ? <span className="ud-kpi__go" aria-hidden="true">↗</span> : null}
      </div>
      <div className="ud-kpi__value">
        {value}
        {unit ? <span className="u"> {unit}</span> : null}
      </div>
      {sub ? <div className="ud-kpi__sub">{sub}</div> : null}
    </>
  );
  return to ? (
    <Link to={to} className="ud-kpi ud-kpi--link" data-testid="ud-kpi-link">{body}</Link>
  ) : (
    <div className="ud-kpi">{body}</div>
  );
};

// Standing-check rise category (derived client-side; the endpoint returns raw HR only).
export const riseCategory = (rise) => {
  if (rise == null || Number.isNaN(rise)) return { key: 'none', label: '—' };
  if (rise >= 30) return { key: 'high', label: 'High' };
  if (rise >= 20) return { key: 'elevated', label: 'Elevated' };
  return { key: 'normal', label: 'Normal' };
};
